import services from './../../../services/service'; // Service Class
import MainScript from './../../Business/main.js'
let service = new services();
export default {
    name: 'ItemsCard',
    mixins: [MainScript],
    data () {
        return {
            set_pop_view:'',
            set_in_view:'',
            set_inner_view:'',
            set_state:{},
            set_locations:{},
            // set_location:{},
            category_thumb_limit:0,
            checkoutComponentKey:0,
        }
    },
  
    components: {},
    methods: {
        setPopViewBox(view){
            this.checkoutComponentKey++;
            this.set_pop_view = view;
            this.toggleSingleComponent('popViewBox');
        },

        checkReOrder(){
            if(this.$route.name == 'ReOrder'){
                this.order_reOrder = true;
                if(this.$route.params.ref && (this.$route.params.ref != '')){
                    //get order details
                    var payload = {
                        order_ref: this.$route.params.ref,
                        order_set_data: 1, //get some order module details
                    }
                    this.getOrderDetails(payload,3); //re-order
                }
            }
        },

        getSellpointPageData(){
            this.loading = true;
            service.getBusinessByUserName(this, this.$route.params.id).then(response => { //Kedi1674857669 //lucas1870509088
                if(response.body.status == 200) {
                    this.sellpoint = response.body.data;
                    this.getSellpointProducts();
                    this.getBusinessAddonProducts();
                    this.getBusinessDeliveryOptions();
                }else{
                    //products
                }
            }).catch((err) => {})
        },
    
        getSellpointProducts(){
            this.loading = true;
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    for(let product of this.products){
                        for(let item of product.product_items){
                            item.product_name = product.product_name;
                            item.product_item_order_quantity = 1; //set as default // for oreder prep
                            item.product_order_options = product.product_information;
                            //set info state
                            for(let option of item.product_order_options){
                                option.set_status = 1; //selected//active//added
                                option.set_details = "";
                            }
                        }
                    }

                    //some setts
                    this.set_order_data.order_items = []; //ini
                    //
                    //--re-order-setts
                    if(this.$route.name == 'ReOrder'){
                        this.checkReOrder();
                    }else{
                        this.loading = false;
                    }
                }
            }).catch((err) => {})
        },

        getBusinessAddonProducts(){
            var payload = {
                data_addon_products: 1,
                data_business: this.sellpoint.business_id
            }
            service.getProductsData(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.business_addon_products = response.body.data;
                    //setts
                    for(let product of this.business_addon_products){
                        for(let item of product.product_items){
                            item.product_name = product.product_name;
                            item.product_item_order_quantity = 1; //set as default // for oreder prep
                            //
                            item.product_order_options = product.product_information;
                            //set info state
                            if(item.product_order_options && (Object.keys(item.product_order_options).length > 0)){
                                for(let option of item.product_order_options){
                                    option.set_status = 1; //selected//active//added
                                    option.set_details = "";
                                }
                            }
                        }
                        //
                        this.set_order_addons.push(product)
                    }
                    //../setts
                } 
            }).catch((err) => {})
        },

        setCategoryProducts(category){
            this.category = category; 
            this.getBusinessCategoryProducts();
        },

        setRequestedProducts(products){
            this.products = products;
            //reset-view
            if(this.set_in_view == 'moreCategories'){
                this.set_in_view = '';
            }
        },
    },
    created: function(){
        if(this.$route.path.name == "Item"){
            this.setProductView(this.products[0],0,this.products[0].product_items[0],0);
        }
        //this.setUserOrderDetails();
        this.getAppDeliveryPartners();
        this.getSellpointPageData();
        //
        if(this.site_view == 1){
            this.category_thumb_limit = 3;
        }else{
            this.category_thumb_limit = 9;
        }
       //this.getSellpointProducts();
        //console.log(900778887);
                   
    }
    
}



// WEBPACK FOOTER //
// ./src/pages/Components/V_ItemsOrder/script.js